const generalEN = {
    "modalConfirm": {
        "button": {
            "cancel": "Cancel",
            "confirm": "Confirm"
        }
    },
    "tableDropdown": {
        "action": "Action",
        "edit": "Edit",
        "delete": "Delete",
        "viewDetails": "View Details",
        "copyMLId": "Copy ML ID",
        "viewStats": "View Stats"
    },
    "tableModal": {
        "cancel": "Cancel",
        "confirm": "Confirm",
        "edit": "Edit"
    },
    "invoiceModal": {
        "button": {
            "cancel": "Cancel",
            "confirm": "Confirm"
        }
    },
    "select": {
        "placeholder": "Select..."
    },
    "asyncDropdown": {
        "placeholder": "Search...",
        "loading": "Loading...",
        "noResults": "No options",
        "blacklisted": "Blacklisted"
    },
    "table": {
        "noDataAvailable": "No data available"
    },
    "tableHelper": {
        "loading": "Loading...",
        "error": "Error occured",
        "noData": "There is no data available"
    },
    "countriesSelect": {
        "placeholder": "Search country..."
    },
    "consentModal": {
        "header": "Consent Required",
        "body": {
            "description": "Please review and accept our new consent terms to continue using our services.",
            "label": {
                "firstName": "First Name",
                "lastName": "Last Name",
                "email": "Email",
                "termsOfUsageAgreement": "I agree with the <1>Terms Of Usage</1>",
                "privacyPolicyAgreement": "I agree with the <1>Privacy Policy</1>",
                "cookiePolicyAgreement": "I agree with the <1>Cookie Policy</1>"
            },
        },
        "button": {
            "submit": "Submit"
        }
    },
    "passwordResetModal": {
        "header": "Change Your Password",
        "body": {
            "form": {
                "label": {
                    "currentPassword": "Current password",
                    "newPassword": "New password",
                    "repeatNewPassword": "Repeat new password"
                },
                "button": {
                    "submit": "Submit"
                },
                "message": {
                    "currentPasswordRequired": "Your old password is required",
                    "newPasswordRequired": "New password is required",
                    "newPasswordMinLength": "Your password should be at least 10 characters long",
                    "newPasswordDifferentFromOld": "New password must be different from the old password",
                    "newPasswordConfirmation": "New password must match"
                }
            }
        },
        "footer": {
            "note": "<strong>Note: </strong>It's been a while since you last updated your password. For your security, please reset your password."
        },
        "message": {
            "success": "Your password has been changed!",
            "error": "Something went wrong! Please refresh page and try again!"
        },
        "modal": {
            "confirm": {
                "header": "Are you sure you would like change your password?",
                "body": "Please confirm"
            }
        }
    },
    "qcFeedback": {
        "label": {
            "qcFeedback": "QC Feedback"
        }
    },
    "subUserFilter": {
        "label": {
            "subUser": "Sub-User: "
        },
        "placeholder": {
            "subUser": "Select Sub-User"
        },
        "button": {
            "reset": "Reset"
        }
    },
    "footer": {
        "label": {
            "copyright": "Copyright © {{year}}",
            "allRightsReserved": "All rights reserved.",
            "privacyPolicy": "Privacy Policy",
            "termsAndConditions": "Terms and Conditions"
        }
    },
    "promoBannerHeader": {
        "exclusiveOfferFor": "Exclusive Offer for",
        "off": "OFF",
        "promoCode": "Promo Code",
        "expiresIn": "Expires in",
        "clickHereToAvailThisOffer": "Click here to Avail this offer",
        "availableOnAllSubscriptionPlans": "Available on all Subscription Plans."
    },
    "promoBanner": {
        "exclusiveOfferFor": "Exclusive Offer for",
        "off": "OFF",
        "limitedTimePromoOffer": "This Limited Time Promo Code has been created exclusively for you. Don't miss this opportunity!",
        "promoCode": "Your Promo Code",
        "expiresIn": "Offer expires in",
        "days": "Days",
        "hours": "Hours",
        "minutes": "Minutes",
        "seconds": "Seconds",
        "availableOnAllSubscriptionPlans": "This exclusive offer is available on all subscriptions plans."
    }
};

export default generalEN;